import { memo } from 'react';
import ReactPaginate from 'react-paginate';
import { Box } from '@bridebook/ui';
import componentStyles from './article-pagination.style';

interface IProps {
  items: number;
  activePage: number;
  isMobile: boolean;
  onSelect: (item: { selected: number }) => void;
  hrefBuilder?: (index: number) => string;
  maxButtons?: number;
}

const ArticlePagination = ({ items, activePage, onSelect, hrefBuilder, isMobile }: IProps) => {
  const styles = componentStyles(isMobile);

  return (
    <Box style={styles.wrapper} data-name="pagination">
      <ReactPaginate
        containerClassName="pagination"
        hrefBuilder={hrefBuilder}
        pageCount={items}
        marginPagesDisplayed={1}
        initialPage={activePage}
        forcePage={activePage}
        onPageChange={onSelect}
        disableInitialCallback
        pageRangeDisplayed={2}
      />
    </Box>
  );
};

export default memo(ArticlePagination);
